import { Schema } from 'effect';
import { SiteId } from './common.js';
/**
 * Request/response DTO schemas for the /user group.
 *
 * Bodies are decoded loosely on purpose: these endpoints have hand-written,
 * translated ProblemDetails for each bad-input case (different `id` per case),
 * and a Schema decode failure can only produce one. So Schema owns the shape
 * and the handler owns the semantics, failing with `HttpProblem` to keep the
 * existing wire contract exactly.
 */
// --- POST /user/:site/search -------------------------------------------------
export const SiteParams = Schema.Struct({ site: SiteId });
export const SearchBody = Schema.Struct({
    email: Schema.optional(Schema.String)
});
/** The normalized shape `toGlobalUserDoc` guarantees. */
const GlobalUserSchema = Schema.Struct({
    uid: Schema.String,
    email: Schema.String,
    name: Schema.String,
    phone: Schema.String,
    publicName: Schema.String,
    provider: Schema.String,
    address: Schema.optional(Schema.String),
    postalCode: Schema.optional(Schema.String),
    city: Schema.optional(Schema.String)
});
export const SearchResponse = Schema.Struct({ user: GlobalUserSchema });
// --- POST /user/:site/profile ------------------------------------------------
export const ProfileBody = Schema.Struct({
    name: Schema.optional(Schema.String),
    email: Schema.optional(Schema.String),
    phone: Schema.optional(Schema.String),
    publicName: Schema.optional(Schema.String)
});
/**
 * The shadow doc is a living document (punch cards, policies, saved subjects,
 * warnings…) that this endpoint round-trips rather than owns, so it is passed
 * through unvalidated instead of being pinned to a schema that would silently
 * drop fields.
 */
export const ProfileResponse = Schema.Struct({
    success: Schema.Boolean,
    user: Schema.Any
});
// --- POST/DELETE /user/:site/subjects ----------------------------------------
export const SubjectType = Schema.Literals(['dog', 'handler']);
export const SubjectUpsertBody = Schema.Struct({
    type: Schema.optional(Schema.String),
    name: Schema.optional(Schema.String),
    formData: Schema.optional(Schema.Record(Schema.String, Schema.mutableKey(Schema.Any)))
});
export const SubjectDeleteBody = Schema.Struct({
    type: Schema.optional(Schema.String),
    name: Schema.optional(Schema.String)
});
export const SuccessResponse = Schema.Struct({ success: Schema.Boolean });
// --- POST /user/:site/policy -------------------------------------------------
export const PolicyBody = Schema.Struct({
    policyId: Schema.optional(Schema.String),
    version: Schema.optional(Schema.String),
    accepted: Schema.optional(Schema.Boolean)
});
export const PolicyResponse = Schema.Struct({
    success: Schema.Boolean,
    policy: Schema.Struct({
        accepted: Schema.Boolean,
        version: Schema.String,
        date: Schema.String
    })
});
// --- POST /user/groups/:siteId/join ------------------------------------------
// Redeem a group join code. See docs/plans/groups.md — the code is spent once per
// person to establish membership, not re-proved on every booking.
export const GroupJoinParams = Schema.Struct({ siteId: SiteId });
export const GroupJoinBody = Schema.Struct({ code: Schema.String });
export const GroupJoinResponse = Schema.Struct({
    joined: Schema.Boolean,
    groupId: Schema.String,
    message: Schema.String
});
//# sourceMappingURL=user.js.map